declare var jsPDF;

namespace TabAurous.Common {
    export class ReportPage extends Serenity.Widget<any> {

        private reportKey: string;
        private propertyItems: Serenity.PropertyItem[];
        private propertyGrid: Serenity.PropertyGrid;

        constructor(element: JQuery) {
            super(element);

            $('.report-link', element).click(e => this.reportLinkClick(e));
            $('div.line', element).click(e => this.categoryClick(e));
            new Serenity.QuickSearchInput($('.s-QuickSearchBar input', element), {
                onSearch: (field, text, done) => {
                    this.updateMatchFlags(text);
                    done(true);
                }
            });
        }

        protected updateMatchFlags(text: string) {
            var liList = $('.report-list', this.element).find('li').removeClass('non-match');
            text = Q.trimToNull(text);
            if (!text) {
                liList.children('ul').hide();
                liList.show().removeClass('expanded');
                return;
            }

            text = Select2.util.stripDiacritics(text).toUpperCase();

            var reportItems = liList.filter('.report-item');
            reportItems.each(function (ix, e) {
                var x = $(e);
                var title = Select2.util.stripDiacritics(Q.coalesce(x.text(), '').toUpperCase());
                if (title.indexOf(text) < 0) {
                    x.addClass('non-match');
                }
            });

            var matchingItems = reportItems.not('.non-match');
            var visibles = matchingItems.parents('li').add(matchingItems);
            var nonVisibles = liList.not(visibles);
            nonVisibles.hide().addClass('non-match');
            visibles.show();
            if (visibles.length <= 100) {
                liList.children('ul').show();
                liList.addClass('expanded');
            }
        }

        protected categoryClick(e) {
            var li = $(e.target).closest('li');
            if (li.hasClass('expanded')) {
                li.find('ul').hide('fast');
                li.removeClass('expanded');
                li.find('li').removeClass('expanded');
            }
            else {
                li.addClass('expanded');
                li.children('ul').show('fast');
                if (li.children('ul').children('li').length === 1 && !li.children('ul').children('li').hasClass('expanded')) {
                    li.children('ul').children('li').children('.line').click();
                }
            }
        }

        protected reportLinkClick(e) {
            e.preventDefault();
            e.preventDefault();
            var key = $(e.target).data('key');
            var dialog;
            var reportkey;
            var title;
            switch (key) {
                // #region Purchase
                case "Purchase.ApprovalRegister":
                    reportkey = "TabAurous.Reports.ApprovalGrid";
                    title = "Register : Consignment"; 
                    break;
                case "Reports.ApprovalReturnRegister":
                    reportkey = "TabAurous.Reports.ApprovalReturnGrid";
                    title = "Register : Consignment Return"; 
                    break;
                case "Reports.PurchaseRegister":
                    reportkey = "TabAurous.Reports.PurchaseRegisterGrid";
                    title = "Register : Invoice"; 
                    break;
                case "Reports.PurchaseReturnRegister":
                    reportkey = "TabAurous.Reports.PurchaseReturnGrid";
                    title = "Register : Return"; 
                    break;
                case "Reports.PurchaseItemsRegister":
                    reportkey = "TabAurous.Purchase.PurchaseItemsRegisterGrid";
                    title = "Register : Purchase Items"; 
                    break;
                case "Purchase.OrderRegister":
                    reportkey = "TabAurous.Reports.OrderRegisterGrid";
                    title = "Register : Order"; 
                    break;
                case "Purchase.OpenConsignmentIn":
                    reportkey = "TabAurous.Reports.OpenConsignmenInGrid";
                    title = "Register :Open Consignment"; 
                    break;
                case "Purchase.OpenConsignmentInDetailed":
                    reportkey = "TabAurous.Reports.OpenConsignmentInDetailed";
                    title = "Register :Open Consignment (Detailed)"; 
                    break;
                case "Purchase.OpenConsignmentInBifurcation":
                    reportkey = "TabAurous.Reports.OpenConsignmentInBifurcation";
                    title = "Register :Open Consignment (Bifurcation)"; 
                    break;
                case "Purchase.GSTR2":
                    reportkey = "TabAurous.Purchase.GSTR2Grid";
                    title = "Report : GSTR - 2"; 
                    break;
                case "Reports.QuotationRegister":
                    reportkey = "TabAurous.Reports.QuotationRegisterGrid";
                    title = "Register : Quotation"; 
                    break; case "SalesOrder.SalesOrder":
                case "Reports.PurchaseMonthlyReport":
                    reportkey = "TabAurous.Reports.PurchaseMonthlyGrid";
                    title = "Register : Purchase Report(Monthly)";
                    break;
                // #endregion 

                // #region Stock
                case "Stock.StoneStock":
                    reportkey = "TabAurous.Reports.StoneStockGrid";
                    title = "Stock : Stone"; 
                    break;
                case "Stock.StoneMovementRegister":
                    reportkey = "TabAurous.Reports.StoneMovementGrid";
                    title = "Movement : Stone"; 
                    break;
                case "Stock.JewelleryMovementRegister":
                    reportkey = "TabAurous.Reports.JewelleryMovementGrid";
                    title = "Movement : Jewellery"; 
                    break;
                case "Stock.JewelleryRegister":
                    reportkey = "TabAurous.Reports.JewelleryStockGrid";
                    title = "Stock : Jewellery"; 
                    break;
                case "Stock.MetalMovementRegister":
                    reportkey = "TabAurous.Reports.MetalMovementGrid";
                    title = "Movement : Metal"; 
                    break;
                case "Stock.MetalRegister":
                    reportkey = "TabAurous.Reports.MetalStockGrid";
                    title = "Stock : Metal"; 
                    break;
                case "Stock.ProductPerformance":
                    reportkey = "TabAurous.Stock.ProductPerformanceGrid";
                    title = "Report : Product Performance"; 
                    break;
                case "Stock.StockAging":
                    reportkey = "TabAurous.Stock.StockAgingGrid";
                    title = "Report : Stock Aging"; 
                    break;
                case "Stock.SupplierPerformance":
                    reportkey = "TabAurous.Stock.SupplierPerformance";
                    title = "Report : Supplier Performance"; 
                    break;

                case "Stock.OwnJewelleryReport":
                    reportkey = "TabAurous.Reports.OwnJewelleryGrid";
                    title = "Movement : Own Jewellery"; 
                    break;
                case "Stock.OwnJewellerySummaryStockReport":
                    reportkey = "TabAurous.Reports.OwnJewellerySummaryGrid";
                    title = "Stock : Own Jewellery (Summary)"; 
                    break;
                case "Stock.OwnMetalReport":
                    reportkey = "TabAurous.Reports.OwnMetalGrid";
                    title = "Movement : Own Metal"; 
                    break;
                case "Stock.OwnStoneReport":
                    reportkey = "TabAurous.Reports.OwnStoneGrid";
                    title = "Stock : Own Stone"; 
                    break;
                case "Stock.StoreDetails":
                    reportkey = "";
                    title = "";
                    dialog = new Stock.StoreDetailsDialog();
                    break;
                case "Stock.JewelleryStockShapeWise":
                    reportkey = "TabAurous.Reports.JewelleryStockShapeWiseGrid";
                    title = "Stock : Jewellery(Shape Wise Bifurcation)"; 
                    break;
                case "Stock.JewelleryCatalogRegister":
                    reportkey = "TabAurous.Reports.JewelleryStockCatalogGrid";
                    title = "Stock : Jewellery"; 
                    break;
                // #endregion 

                // #region Retail

                case "Retail.Exchange":
                    reportkey = "TabAurous.Retail.ExchangeRegisterGrid";
                    title = "Register : Exchange"; 
                    break;
                case "Retail.FootfallandSales":
                    reportkey = "TabAurous.Retail.FootfallAndSales";
                    title = "Report : Footfall and Sales"; 
                    break;
                case "Retail.POSReturn":
                    reportkey = "TabAurous.Retail.POSReturnRegisterGrid";
                    title = "Register : POS Return"; 
                    break;
                case "Retail.POSSales":
                    reportkey = "TabAurous.Retail.POSSalesRegisterGrid";
                    title = "Register : POS Sales"; 
                    break;
                case "Retail.ProductWise":
                    reportkey = "TabAurous.Retail.ProductWiseSalesGrid";
                    title = "Report : Product Wise Sales"; 
                    break; 
                case "Retail.SalesPersonWiseSales":
                    reportkey = "TabAurous.OMS.SalesPersonWiseSales";
                    title = "Report : Sales (Person Wise)"; 
                    break;
                case "Retail.Seasonality":
                    reportkey = "TabAurous.Retail.SeasonalityReport";
                    title = "Report : Seasonality"; 
                    break;
                case "Retail.TimeWise":
                    reportkey = "";
                    title = "";
                    dialog = new Retail.TimeWiseDialog();
                    break;
                case "Retail.POSOrderStatus":
                    reportkey = "TabAurous.Reports.POSOrderStatusGrid";
                    title = "Register :Order Status"; 
                    break;
                case "Retail.GSTR1B2CS":
                    reportkey = "TabAurous.Retail.GSTR1B2CSGrid";
                    title = "Report : GSTR - 1 B2CS"; 
                    break;
                case "Retail.StoreDetails":
                    reportkey = "";
                    title = "";
                    dialog = new Retail.StoreDetailsDialog();
                    break;
                case "Retail.OpenConsignmentOut":
                    reportkey = "TabAurous.Reports.POSOpenConsignmenOutGrid";
                    title = "Register :Open Consignment"; 
                    break;
                case "Retail.OpenConsignmentOutDetailed":
                    reportkey = "TabAurous.Reports.POSOpenConsignmentOutDetailedGrid";
                    title = "Register :Open Consignment(Detailed)"; 
                    break;
                case "Retail.OpenConsignmentBifurcation":
                    reportkey = "TabAurous.Reports.OpenConsignmentBifurcation";
                    title = "Register :Open Consignment (Bifurcation)"; 
                    break;
                // #endregion 

                // #region Production
                case "Finance.TrialBalance":
                    reportkey = "TabAurous.Reports.TrialBalanceGrid";
                    title = "Statement : Trial Balance"; 
                    break;
                case "Finance.ProfitandLoss":
                    reportkey = "TabAurous.Reports.ProfitandLossGrid";
                    title = "Statement : Proft & Loss"; 
                    break;
                case "Finance.BalanceSheet":
                    reportkey = "TabAurous.Reports.BalanceSheetGrid";
                    title = "Statement : Balance Sheet";
                    break;
                case "Finance.AccountReceivable":
                    reportkey = "TabAurous.Finance.AccountReceivableGrid";
                    title = "Register : Accounts Receivable"; 
                    break;
                case "Finance.AccountPayable":
                    reportkey = "TabAurous.Finance.AccountPayableGrid";
                    title = "Register : Accounts Payable"; 
                    break;
                case "Finance.CashFlow":
                    reportkey = "TabAurous.OMS.CashFlowGrid";
                    title = "Statement : Cash Flow"; 
                    break;
                case "Finance.Payment":
                    reportkey = "TabAurous.Finance.PaymentRegisterGrid";
                    title = "Register : Payment"; 
                    break;
                case "Finance.Receipt":
                    reportkey = "TabAurous.Finance.ReceiptRegisterGrid";
                    title = "Register : Receipt"; 
                    break;
                case "Finance.Contra":
                    reportkey = "TabAurous.Finance.ContraRegisterGrid";
                    title = "Register : Contra Register"; 
                    break;
                case "Finance.Journal":
                    reportkey = "TabAurous.Finance.JournalRegisterGrid";
                    title = "Register : Journal"; 
                    break;
                case "OMS.LedgerPosting":
                    reportkey = "TabAurous.OMS.LedgerPostingGrid";
                    title = "Statement : Statement of Accounts"; 
                    break;
                // #endregion  

                // #region Inventory
                case "Inventory.BranchInRegister":
                    reportkey = "TabAurous.Inventory.BranchInRegisterGrid";
                    title = "Register : Branch In"; 
                    break;
                case "Inventory.BranchOutRegister":
                    reportkey = "TabAurous.Inventory.BranchOutRegisterGrid";
                    title = "Register : Branch Out"; 
                    break;
                case "Inventory.LocationTransferRegister":
                    reportkey = "TabAurous.Inventory.LocationTransferRegisterGrid";
                    title = "Register : Location Transfer"; 
                    break;
                case "Inventory.MaterialPaymentRegister":
                    reportkey = "TabAurous.Inventory.MaterialPaymentRegisterGrid";
                    title = "Register : Material Payment"; 
                    break;
                case "Inventory.MaterialReceiptRegister":
                    reportkey = "TabAurous.Inventory.MaterialReceiptRegisterGrid";
                    title = "Register : Material Receipt"; 
                    break;
                // #endregion 

                // #region JobWork

                case "JobWork.JobWorkOrder":
                    reportkey = "TabAurous.Reports.JobWorkOrderGrid";
                    title = "Report : JobWork Order"; 
                    break;
                case "JobWork.JobTransaction":
                    reportkey = "TabAurous.Reports.JobTransactionGrid";
                    title = "Report : JobWork Order"; 
                    break;
                // #endregion 

                // #region Production

                case "Production.WhatIsWhere":
                    reportkey = "TabAurous.Production.WhatIsWhereGrid";
                    title = "Register : What-Is-Where"; 
                    break;
                case "Production.WhatIsWhereDepartmentWise":
                    reportkey = "TabAurous.Production.WhatIsWhereDepartmentWiseGrid";
                    title = "Register : What-Is-Where"; 
                    break;
                case "Production.WhatIsWhereOrderWise":
                    reportkey = "TabAurous.Production.WhatIsWhereOrderWiseGrid";
                    title = "Register : What-Is-Where"; 
                    break;
                case "Production.BagHistory":
                    reportkey = "TabAurous.Production.Bag_HistoryGrid";
                    title = "Register : Bag History"; 
                    break;
                case "Production.LossReport":
                    reportkey = "TabAurous.Production.LossReportGrid";
                    title = "Register : Loss Report"; 
                    break;
                case "Production.LossReportBagWise":
                    reportkey = "TabAurous.Production.LossReportBagWiseGrid";
                    title = "Register : Loss Report(Bag Wise)"; 
                    break;
                case "Production.LossReportDepartmentWise":
                    reportkey = "TabAurous.Production.LossReportDepartmentWiseGrid";
                    title = "Register : Loss Report(Department Wise)"; 
                    break;
                case "Production.LossReportOrderWise":
                    reportkey = "TabAurous.Production.LossReportOrderWiseGrid";
                    title = "Register : Loss Report(Order Wise)"; 
                    break;
                case "Production.LossReportProductWise":
                    reportkey = "TabAurous.Production.LossReportProductWiseGrid";
                    title = "Register : Loss Report(Product Wise)"; 
                    break;
                case "Production.OpenWorkOrders":
                    reportkey = "TabAurous.Production.OpenWorkOrdersGrid";
                    title = "Register : Open Work Orders"; 
                    break;
                case "Production.IssueAgainstWorkOrder":
                    reportkey = "TabAurous.Production.IssueAgainstWorkOrderGrid";
                    title = "Register : Issue Against WorkOrder"; 
                    break;
                case "Production.ReceiptAgainstWorkOrder":
                    reportkey = "TabAurous.Production.ReceiptAgainstWorkOrderGrid";
                    title = "Register : Receipt Against WorkOrder"; 
                    break;
                case "Production.WorkOrderSummary":
                    reportkey = "TabAurous.Production.WorkOrderSummaryGrid";
                    title = "Register : Job Card Summary";
                    break;
                case "Production.QualityInspectionSummary":
                    reportkey = "TabAurous.Production.QualityInspectionSummaryGrid";
                    title = "Register : Quality Inspection Summary"; 
                    break;
                case "Production.JobWorkMetalReport":
                    reportkey = "TabAurous.Production.JobWorkMetalReportGrid";
                    title = "Register : Job Work Metal Register"; 
                    break;
                case "Production.MetalWIPStockBagWiseReport":
                    reportkey = "TabAurous.Production.MetalWIPStockBagWiseGrid";
                    title = "WIP Stock(Bag Wise)";  
                    break;
                case "Production.MetalWIPStockDepartmentWiseReport":
                    reportkey = "TabAurous.Production.MetalWIPStockDepartmentWiseGrid";
                    title = "WIP Stock(Department Wise)"; 
                    break;
                case "Production.MetalWIPStockDepartmentBagWiseReport":
                    reportkey = "TabAurous.Production.MetalWIPStockDepartmentBagWiseGrid";
                    title = "Department/Bag Wise"; 
                    break;
                case "Production.StoneWIPStockBagWiseReport":
                    reportkey = "TabAurous.Production.StoneWIPStockBagWiseGrid";
                    title = "WIP Stock(Bag Wise)"; 
                    break;
                case "Production.StoneWIPStockDepartmentWiseReport":
                    reportkey = "TabAurous.Production.StoneWIPStockDepartmentWiseGrid";
                    title = "Department Wise"; 
                    break;
                case "Production.StoneWIPStockDepartmentBagWiseReport":
                    reportkey = "TabAurous.Production.StoneWIPStockDepartmentBagWiseGrid";
                    title = "Department/Bag Wise"; 
                    break;
                // #endregion 

                // #region Transactions
                case "Transactions.PriceBifurcation":
                    reportkey = "TabAurous.Reports.PriceBifurcationGrid";
                    title = "Price Bifurcation"; 
                    break;
                case "Transactions.ShortList":
                    reportkey = "TabAurous.Reports.ShortListGrid";
                    title = "Short List(Voucher Wise)"; 
                    break;
                case "Transactions.ShortListCategoryWiseRegister":
                    reportkey = "TabAurous.Reports.ShortListCategoryWiseGrid";
                    title = "Short List(Category Wise)";
                    break;
                case "Transactions.StoneBifurcation":
                    reportkey = "TabAurous.Reports.StoneBifurcationGrid";
                    title = "Stone Bifurcation"; 
                    break;
                case "Transactions.StockBifurcation":
                    reportkey = "TabAurous.Reports.StockBifurcationGrid";
                    title = "Jewellery Stock (Detailed)"; 
                    break;
                case "Transactions.ItemsRegister":
                    reportkey = "TabAurous.Reports.ItemsRegisterGrid";
                    title = "Items Register"; 
                    break;
                case "Transactions.JewelleryStockShapeandVoucherWise":
                    reportkey = "TabAurous.Reports.JewelleryStockShapeandVoucherWiseGrid";
                    title = "Stock : Jewellery(Shape Wise Bifurcation)"; 
                    break;
                case "Transactions.JewelleryStockShapeandVoucherWise":
                    reportkey = "TabAurous.Reports.ItemsRegisterGrid";
                    title = "Items Register";
                    break;
                case "Transactions.JewelleryTagSheet":
                    reportkey = "TabAurous.Reports.JewelleryTagSheetGrid";
                    title = "Tag Sheet";
                    break;
                case "Transactions.JewelleryTagSheet2":
                    reportkey = "TabAurous.Reports.JewelleryTagSheet2Grid";
                    title = "Tag Sheet 2";
                    break;
                // #endregion  

                // #region Sales  
                case "ApprovalOutReturn.ApprovalOutReturn":
                    reportkey = "TabAurous.Sales.ApprovalReturnGrid";
                    title = "Register : Approval Return";
                    break;
                case "ApprovalOut.ApprovalOut":
                    reportkey = "TabAurous.Sales.ApprovalGrid";
                    title = "Register : Approal";
                    break;
                case "Sales.SalesMaster":
                    reportkey = "TabAurous.Sales.SalesGrid";
                    title = "Register : Sales";
                    break;
                case "SalesReturn.SalesReturnMaster":
                    reportkey = "TabAurous.Sales.SalesReturnGrid";
                    title = "Register : Return"; 
                    break;
                case "Sales.SalesItemsRegister":
                    reportkey = "TabAurous.Sales.SalesItemsRegisterGrid";
                    title = "Register : Sales Items"; 
                    break;
                case "Sales.Customer":
                    reportkey = "TabAurous.Reports.CustomerSalesGrid";
                    title = "Report : Customer Sales"; 
                    break;
                case "Sales.CustomerSalesItems":
                    reportkey = "TabAurous.Reports.CustomerSalesItemsGrid";
                    title = "Report : Customer Sales (Item Wise)"; 
                    break;
                case "Sales.ProductSalesItems":
                    reportkey = "TabAurous.Reports.ProductSalesItemsGrid";
                    title = "Report : Product Sales (ItemWise)"; 
                    break;
                case "Sales.CategoryWiseSales":
                    reportkey = "";
                    title = "";
                    dialog = new Common.SalesSummaryReportDialog();

                    break;
                case "Sales.CategoryWiseSalesByPrice":
                    reportkey = "TabAurous.Sales.CategoryWiseSalesByPriceGrid";
                    title = "Category Wise Sales(By Price)"; 
                    break;
                case "Sales.RFM":
                    reportkey = "TabAurous.Sales.RFMAnalysisGrid";
                    title = "Report : Recency Frequency Monetary (RFM)"; 
                    break;
                case "Sales.Quotation":
                    reportkey = "TabAurous.Sales.QuotationRegisterGrid";
                    title = "Register : Quotation"; 
                    break;
                case "Sales.OpenConsignmentOut":
                    reportkey = "TabAurous.Reports.OpenConsignmentOutGrid";
                    title = "Register :Open Consignment"; 
                    break;
                case "Sales.OpenConsignmentOutDetailed":
                    reportkey = "TabAurous.Reports.OpenConsignmentOutDetailedGrid";
                    title = "Register :Open Consignment Detailed"; 
                    break;
                case "Sales.OrderStatus":
                    reportkey = "TabAurous.Reports.OrderStatusGrid";
                    title = "Register :Order Status"; 
                    break;
                case "Sales.GSTR1":
                    reportkey = "TabAurous.Sales.GSTR1Grid";
                    title = "Report : GSTR - 1"; 
                    break;
                case "SalesOrder.SalesOrder":
                    reportkey = "TabAurous.SalesOrder.OrderRegisterGrid";
                    title = "Register : Sales Order"; 
                    break;
                // #endregion 
            }
            if (reportkey != "" && title != "") {
                var options: any = {
                    reportkey: reportkey,
                    title: title
                }
                dialog = new Common.ReportTemplateDialog(options);
            }
            dialog.dialogOpen();
        }
    }
}
